import React from 'react';
import gql from "graphql-tag";

export const GET_CONFIG = gql`
    query config{
        config{
            pricePerPerson
            pricePerMile
            boatCapacity
            allowSubmitRide
            noRideMessage
        }  
    }
`

export const UPDATE_CONFIG = gql`
    mutation updateConfig($pricePerPerson: Float, $pricePerMile: Float, $boatCapacity: Int, $allowSubmitRide: Boolean, $noRideMessage: String) {
        updateConfig (data: {
            pricePerPerson: $pricePerPerson
            pricePerMile: $pricePerMile
            boatCapacity: $boatCapacity
            allowSubmitRide: $allowSubmitRide
            noRideMessage: $noRideMessage
        }) {
            success
            message
        }
    }
`